<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    data () {
      return {
        dateNow: moment().format('YYYY-MM-DD')
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      config () {
        return {
          // CONFIG PARSING API
          api: `admin/attendance?date[eq]=${this.dateNow}&status[in]=ijin,leave,cuti`,

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'Nama Lengkap',
              width: '400px',
              value: 'user_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Status',
              width: '200px',
              value: 'status',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal & Waktu Datang',
              width: '200px',
              value: 'start_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            },
            {
              text: 'Tanggal & Waktu Pulang',
              width: '200px',
              value: 'end_datetime',
              freeze: false,
              hide: false,
              format: 'datetime'
            },
            {
              text: 'Presensi Dari',
              width: '200px',
              value: 'attendance_by',
              freeze: false,
              hide: false
            },
            {
              text: 'Latitude Mulai',
              width: '200px',
              value: 'start_latitude',
              freeze: false,
              hide: false
            },
            {
              text: 'Longitude Mulai',
              width: '200px',
              value: 'start_longitude',
              freeze: false,
              hide: false
            },
            {
              text: 'Range Mulai',
              width: '200px',
              value: 'start_range',
              freeze: false,
              hide: false
            },
            {
              text: 'Latitude Selesai',
              width: '200px',
              value: 'end_latitude',
              freeze: false,
              hide: false
            },
            {
              text: 'Longitude Selesai',
              width: '200px',
              value: 'end_longitude',
              freeze: false,
              hide: false
            },
            {
              text: 'Range Selesai',
              width: '200px',
              value: 'end_range',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            edit: {
              button: false,
              api: '',
              window: false,
              href: ''
            },
            delete: {
              button: false,
              api: ''
            },
            detail: {
              button: false,
              api: ''
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            reset: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>